$(document).ready(function() {
    //collapse
  	$(".container_collapse .header").on("click", function() {
        let $header = $(this);
        //getting the next element
        $content = $header.next();
      	
        //open up the content needed - toggle the slide- if visible, slide up, if not slidedown.
        $content.slideToggle(500, function() {
            //execute this after slideToggle is done
            //change text of header based on visibility of content div
          	
          	if($content.is(":visible")){
            	$header.find(".col_symbol").text("-");
            }else{
            	$header.find(".col_symbol").text("+");
            }
        })
        $content.find(".tabs li a:first").removeClass('inactive');
    })
    // tabs in collapse
    
    $('.container_collapse .tabs li a').slice(1).addClass('inactive');
  	$('.container_collapse .content .tab_box').hide();
	$('.container_collapse .content').find(".tab_box:first").show();
    $('.tabs li a').click(function(){
        var $this = $(this);
      	var id = $this.attr("data-id");
      	let index_collap = id.slice(0, 1);
//       	console.log(index_collap);
        if($this.hasClass('inactive')){ //this is the start of our condition 
            $('.tab_chart_'+index_collap+' .tabs li a').addClass('inactive');           
            $this.removeClass('inactive');

            $('.tab_chart_'+index_collap+' .tab_box' ).hide();
            $("#tab_"+id).fadeIn('slow');
       }
    });
    // active bold text
    $(".sidebar_quest").on("click", function() {
    	let $this = $(this);
      	$(".sidebar_quest").removeClass("font-weight-bold");
      	$this.addClass("font-weight-bold");
    })
    $(".btn-custom").on("click", function(){
    	var $this = $(this);
      	var id_flag = $this.attr("data-target");
      	$(".collapse").hide();
      	$(id_flag).slideToggle( "fast");
    })
    
    //custom photo
    
      var productJsonElem = $("#ProductJson-product-template");
  var swatchOptionsElem = $('.swatch_options');
  var productData = productJsonElem.length ? JSON.parse(productJsonElem.html()) : null;
  if (productData) {
    swatchOptionsElem.on('change', 'input,select', function() {
      refresh();
    });
    function refresh() {
      var optionsLength = swatchOptionsElem.find('.swatch').length;
      var matchVariant = productData.variants.filter(function (variant) {
        var match = true;
        for (var i = 1; i <= optionsLength; i++) {
          if (variant["option" + i] !== $("[name='option-"+(i - 1)+"']:checked").val()) {
            match = false;
            break;
          }
        }
        return match;
      });
      var selectedVariant = matchVariant.length ? matchVariant[0] : null;
      if (selectedVariant) {
        $("[name='id']").val(selectedVariant.id);
        if (selectedVariant.available) {
          if (selectedVariant.compare_at_price) {
            $("#ComparePrice .money").text(
                    Shopify.formatMoney(selectedVariant.compare_at_price, theme.strings.moneyFormat)
            );
            $("#ComparePrice").show();
          } else {
            $("#ComparePrice").hide();
          }

          $("#ProductPrice").attr('content', selectedVariant.price.toFixed(2));
          $("#ProductPrice .money").text(Shopify.formatMoney(selectedVariant.price, theme.strings.moneyFormat));

          $("#AddToCart--product-template").prop('disabled', false);
          $("#AddToCart--product-template .btn__add-to-cart-text").text('Add to Cart');
        } else {
          $("#AddToCart--product-template").prop('disabled', true);
          $("#AddToCart--product-template .btn__add-to-cart-text").text('Sold out');
        }
      }
    }
    swatchOptionsElem.find('.swatch').each(function (i, s) {
      var option = $(s).data('optionIndex');
      $('input[name="option-'+option+'"]').prop('checked', false);
      $('input[name="option-'+option+'"]').first().prop('checked', true);

      $('select[name="option-'+option+'"] option').prop('selected', false);
      $('select[name="option-'+option+'"] option').first().prop('selected', true);
    });
    refresh();
  }
//   $("#CustomPhoto").on('change', function (e) {
//     var input = e.target;
//     var file = input.files.length ? input.files[0] : null;
//     if (file) {
//       var reader = new FileReader();
//       reader.onload = function (r) {
//         $("[name='properties[Custom Photo]']").val(r.target.result);
//         $(".custom-photo-wrapper .custom-photo-preview img").attr('src', r.target.result);
//         $(".custom-photo-preview").show();
//       }
//       reader.readAsDataURL(file);
//     }
//   });
  
  $("#CustomPhoto").on('change', function (e) {
    var input = e.target;
    var file = input.files.length ? input.files[0] : null;
    if (file) {
      var reader = new FileReader();
      reader.onload = function (r) {
        
        var data = {
            upload_preset: "mvprfsmn", // the unsigned image preset within cloudinary
            tags: "foo", // any tags you wish to apply
            context: "photo=phototitle",
            file: r.target.result // the BASE64 encoded image file http://stackoverflow.com/questions/6978156/get-base64-encode-file-data-from-input-form
        }

        // standard Jquery ajax post

        jQuery.post("https://842777188687184:-vB58cVtyPuZkPodrYAra4U9YdU@api.cloudinary.com/v1_1/dpepdeqli/upload", data).done(function(data) {
           // do something here
//           alert('done');
          
        }).then(function(data) {
          $("[name='properties[Custom Photo]']").val(data.secure_url);
        });
        
        
//         $("[name='properties[Custom Photo]']").val(r.target.result);
        $('[name="properties[Custom Photo]"]').prop('disabled', false);
        
        $(".customer-photo-wrapper .customer-photo-preview img").attr('src', r.target.result);
        $(".customer-photo-preview").show();
      }
      reader.readAsDataURL(file);
    }
  });

  $("body").on('change', '.current-checked-Type', function() {
    refreshCustomPhotoBlock();
  });

  function refreshCustomPhotoBlock() {
    var selectedType = $('.current-checked-Type:checked').val();
//     if (selectedType && selectedType.toLowerCase() === 'custom photo') {
    if (selectedType && selectedType.toLowerCase().includes('custom photo')) {
      $('.custom-photo-wrapper').show();
      $('[name="properties[Custom Photo]"]').prop('disabled', false);
    } else {
      $('.custom-photo-wrapper').hide();
      $('[name="properties[Custom Photo]"]').prop('disabled', true);
    }
  }

//   $(".swatch_options").children('.swatch').each(function (i, s) {
//     $(s).find('.swatch-element').first().find('label').trigger('click');
//   });
  refreshCustomPhotoBlock();
    //
})